export default __webpack_public_path__ + "static/media/img7.3b07f716.jpg";